export default class OpenIdAuthorization {
	route = null;
	router = null;
	mainStore = null;
	siteId = null;

	constructor(route, router, mainStore)
	{
		this.route = route;
		this.router = router;
		this.mainStore = mainStore;
		this.siteId = mainStore.solution;
	}


	async checkAuthorization() {
		if (process.client) {
			let hasLoginRedirect = 'login-redirect' in this.route.query;
			let authCode = this.route.query.code;
			if (hasLoginRedirect && authCode !== undefined && authCode !== '') {
				var ok = await this.authOpenIdLogin(authCode);
				if (ok)
				{
					this.mainStore.setNotificationMessage('Du er logget ind', null, 10);

					this.router.push({
						path: this.route.path + "",
						query: null
					});
			
				}
			}
		}
	};


	async authOpenIdLogin(code) {
		return await $fetch('/api/openid/authorize?siteId=' + this.siteId + '&code=' + code, {
			method: 'GET',
			headers: useRequestHeaders(['cookie']),
		})
			.then((response) => {
				return true;
			})
			.catch(() => {
				return false;
			});
	}
	

}